import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Preview-only debug logger of the hosting platform – never loaded on the production domain.
if (window.location.hostname.endsWith("emergentagent.com")) {
  const el = document.createElement("script");
  el.src = "https://assets.emergent.sh/scripts/emergent-main.js";
  document.head.appendChild(el);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
